export { default as VanIcon, createVanIconComponent } from "./VanIcon"
